// src/mySettings/settingComponent/accountSetting/WarningSetting.js — delete account

import React, { useState } from 'react';
import './warningSetting.css';
import { unregisterAllListeners } from '../../../components/appComponents/ListenerManager';
import { auth } from '../../../firebase';
import { useNavigate } from 'react-router-dom';
import { getFunctions, httpsCallable } from 'firebase/functions';

const WarningSetting = () => {
  const [showModal, setShowModal] = useState(false);
  const [isDeletingAccount, setIsDeletingAccount] = useState(false);
  const [deleteError, setDeleteError] = useState('');
  const navigate = useNavigate();

  const closeModal = () => {
    setShowModal(false);
    setDeleteError('');
  };

  const handleConfirmDelete = async () => {
    setIsDeletingAccount(true);
    setDeleteError('');
    try {
      await httpsCallable(getFunctions(), 'deleteUser')();
      unregisterAllListeners();
      await auth.signOut();
      navigate('/');
    } catch {
      setDeleteError('Your account could not be deleted. Please try again or contact support.');
      setIsDeletingAccount(false);
    }
  };

  return (
    <>
      {/* Deleting Account Overlay */}
      {isDeletingAccount && (
        <div className="bulk-delete-overlay">
          <div className="bulk-delete-dialog">
            <div className="bulk-delete-spinner" />
            <div className="bulk-delete-text">Deleting Account…</div>
          </div>
        </div>
      )}

      <div className="setting-header">Danger zone</div>

      <div className="account-settings-container">
        <div className="settings-row">
          <div className="settings-label">
            <span>Delete account</span>
            <div className="settings-subtitle">
              Permanently delete your account and data
            </div>
          </div>
          <div className="settings-field">
            <button className="ui-setting-button ui-setting-button--danger" onClick={() => setShowModal(true)}>
              Delete
            </button>
          </div>

        </div>

        {/* Confirmation Modal */}
        {showModal && (
          <div className="warning-modal-overlay">
            <div className="warning-modal">
              
              {/* Modal Header with Title & Close Button */}
              <div className="warning-modal-header">
                <h2>Confirm Account Deletion</h2>
                <button className="warning-modal-close" onClick={closeModal} aria-label="Close">
                  &times;
                </button>
              </div>
              
              {/* Modal Content */}
              <div className="warning-modal-content">
                <p>
                  Before you delete your account, please take a moment to understand what
                  will happen to your data:
                </p>
                <ul className="warning-list">
                  <li><b>You cannot create a new account using the same email address.</b></li>
                  <li>Your profile details, preferences, and settings will be removed.</li>
                  <li>
                    You won't be able to access past videos processed,
                    workspaces, or past transactions.
                  </li>
                </ul>
                <p>
                  All data will be permanently deleted immediately upon account deletion.
                  <strong> Keep in mind that deleting your account can’t be undone.</strong>
                </p>
                {deleteError && <p className="warning-error">{deleteError}</p>}
              </div>
              
              {/* Modal Footer with Buttons */}
              <div className="warning-modal-footer">
                <button className="warning-cancel-button" onClick={closeModal}>
                  Cancel
                </button>
                <button className="warning-confirm-delete-button" onClick={handleConfirmDelete}>
                  Confirm Deletion
                </button>
              </div>

            </div>
          </div>
        )}

      </div>
    </>
  );
};

export default WarningSetting;
